<template>
  <div class="content d-flex flex-column flex-column-fluid" id="kt_content">
    <!--begin::Toolbar-->
    <div class="toolbar" id="kt_toolbar">
      <!--begin::Container-->
      <app-sub-view-header :title="title" :breadcrumbs="breadcrumbs" :back="false"></app-sub-view-header>
      <!--end::Container-->
    </div>
    <div class="post d-flex flex-column-fluid" id="kt_post">
      <!--begin::Container-->
      <div id="kt_content_container" class="container-xxl">
        <!--begin::Layout-->
        <div class="d-flex flex-column flex-lg-row">
          <!--begin::Content-->
          <div class="flex-lg-row-fluid mb-10 mb-lg-0 me-lg-7 me-xl-10">
            <!--begin::Card-->
            <div class="card">
              <!--begin::Card body-->
              <div class="card-body p-12">
                <!--begin::Form-->
                <form action="" id="kt_invoice_form">
                  <!--begin::Wrapper-->
                  <div class="d-flex flex-column align-items-start flex-xxl-row">
                    <!--begin::Input group-->
                    <div class="d-flex flex-center flex-equal fw-row text-nowrap order-1 order-xxl-2 me-4" data-bs-toggle="tooltip" data-bs-trigger="hover">
                      <span class="fs-2x fw-bolder text-gray-800"> {{$t('shop.shop_entry')}} # {{  entryShop.numero  }} </span>
                      <!--<input type="text" class="form-control form-control-flush fw-bolder text-muted fs-3 w-125px" value="2021001" /> -->
                    </div>
                    <!--end::Input group-->
                  </div>
                  <!--end::Top-->
                  <!--begin::Separator-->
                  <div class="separator separator-dashed my-10"></div>
                  <!--end::Separator-->
                  <!--begin::Wrapper-->
                  <div class="mb-0">
                    <!--begin::Row-->

                    <!--end::Row-->
                    <!--begin::Table wrapper-->
                    <div class="table-responsive mb-10">
                      <!--begin::Table-->
                      <table class="table g-5 gs-0 mb-0 fw-bolder text-gray-700 table-responsive-sm" data-kt-element="items">
                        <!--begin::Table head-->
                        <thead>
                        <tr class="border-bottom fs-7 fw-bolder text-gray-700 text-uppercase">
                          <th class="min-w-300px w-350px">{{$t('shop.item')}}</th>
                          <th class="min-w-100px w-100px">{{$t('shop.qty')}}</th>
                          <th class="min-w-100px w-100px text-end">{{$t('shop.conform_quantity')}}</th>
                          <th class="min-w-150px w-250px" > </th>

                        </tr>
                        </thead>
                        <!--end::Table head-->
                        <!--begin::Table body-->
                        <tbody>

                        <tr class="border-bottom border-bottom-dashed" data-kt-element="item" v-for="(content, key) in entryInfo.productSaleElements" :key="key">
                          <td class="ps-0">
                            <input type="text" readonly class="form-control form-control-solid mb-2" v-model="content.name"/>
                          </td>
                          <td class="ps-0">
                            <input readonly class="form-control form-control-solid" type="number"  v-model="content.product_quantity"/>
                          </td>
                          <td class="pt-8 text-end text-nowrap">
                            <input type="text"  v-if="content.status === 'no'" readonly class="form-control form-control-solid mb-2" :v-model="$t('shop.shop_unconform')"/>
                            <input type="text"  v-if="content.status === 'yes'" readonly class="form-control form-control-solid mb-2" :v-model="$t('shop.shop_conform')" disabled/>
                          </td>
                          <td class="pe-7"  v-if="content.status === 'no'">
                            <input type="number" class="form-control form-control-solid " v-model="content.received_quantity" readonly />
                          </td>
                        </tr>
                        </tbody>
                        <!--end::Table body-->
                        <!--begin::Table foot-->

                        <!--end::Table foot-->
                      </table>

                    </div>
                  </div>
                  <!--end::Wrapper-->
                </form>
                <!--end::Form-->
              </div>
              <!--end::Card body-->
            </div>
            <!--end::Card-->
          </div>
          <!--end::Content-->

        </div>
        <!--end::Layout-->
      </div>
      <!--end::Container-->
    </div>

  </div>
</template>

<script>
import AppSubViewHeader from "@/views/Shop/partials/AppSubViewHeader";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "View",
  components: {AppSubViewHeader},
  data(){
    return {
      breadcrumbs: [
        {
          name: i18n.global.t('shop.shop_details_entry'),
          path: '/admin/shops'
        },
      ],

      entryInfo: {
        productSaleElements : [],
      },
      entryShop: {}
    }
  },

  async mounted(){
    $('body .pre').css('display', 'block')
      let response = await this.showShopEntryProduct({shop_id: this.$route.params.id, entry_id: this.$route.params.entry_id})
      this.entryInfo.productSaleElements = response?.data?.productSaleElements_collection
      this.entryShop = response?.data?.entry_shop
    $('body .pre').css('display', 'none')
  },

  methods: {
    ...mapActions('shop',[
      'showShopEntryProduct',
    ]),

    navigateRoute(link){
      this.$router.push({name : link})
    }
  }
}
</script>

<style scoped>

</style>